export default __webpack_public_path__ + "static/media/tl1.d31e778b.webp";